export const isDesktop = () => {
  const isDesktopUA = !/android|iphone|ipad|ipod|mobile/i.test(navigator.userAgent);
  const isWideScreen = window.innerWidth >= 1280;
  return isDesktopUA || isWideScreen;
};

export const hasField = (obj: unknown, key: string): boolean =>
  !!obj && Object.prototype.hasOwnProperty.call(obj as Record<string, unknown>, key);
